import React from "react";
import { useForm } from "react-hook-form";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const Filterhead = () => {


  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();


  return (
    <div className="filterhead SearchHead">
      <div className="uk-width-1-1 uk-card  uk-card-default">
        <form onSubmit={handleSubmit}>
        
        <ul  className="uk-list uk-flex uk-flex-around uk-flex-wrap ">


          <li style={{marginTop:'10px'}}>
          <input {...register("OrderNum")} className="uk-input" type="text" placeholder="Order" aria-label="100"/>
          </li>



          <li>
          <input {...register("Name")} className="uk-input" type="text" placeholder="Name" aria-label="100"/>

          </li>
          <li>
          <input {...register("Contact")} className="uk-input" type="text" placeholder="Contact" aria-label="100"/>

          </li>

      
          <li>
          <input {...register("Deposit Slip")} className="uk-input" type="text" placeholder="Deposit Slip" aria-label="100"/>
          </li>

          <li>
            <div className="formInput">
              <select {...register("Product")} name="" className="uk-select" style={{borderRadius:'0px'}}>
                <option value="" selected>
                Product
                </option>
                <option value="Karachi">Ski White</option>
                <option value="Karachi">Surf Blue</option>
                <option value="Skardu">Quantum Black</option>
              </select>
            </div>
          </li>


          <li>
            <div className="formInput">
              <select {...register("Variant")} name="" className="uk-select" style={{borderRadius:'0px'}}>
                <option value="" selected>
                Variant
                </option>
                <option value="Karachi">Ski White</option>
                <option value="Karachi">Surf Blue</option>
              </select>
            </div>
          </li>


          <li>
            <div className="formInput">
              <select {...register("ExteriorColor")}  name="" className="uk-select" style={{borderRadius:'0px'}}>
                <option value="" selected>
                Exterior Color
                </option>
                <option value="Karachi">Ski White</option>
                <option value="Karachi">Surf Blue</option>
                <option value="Skardu">Quantum Black</option>
                <option value="Skardu">Cosmos Black</option>
              </select>
            </div>
          </li>
          <li>
            <div className="formInput">
              <select {...register("InteriorColor")}  name="" className="uk-select" style={{borderRadius:'0px'}}>
                <option value="" selected>
                Interior Color
                </option>
                <option value="Karachi">Black</option>
                <option value="Skardu">Blue Black</option>
                <option value="Skardu">Blue Grey</option>
              </select>
            </div>
          </li>

          <li>
            <div className="formInput">
              <select {...register("PayStatus")} name="" className="uk-select" style={{borderRadius:'0px'}}>
                <option value="" selected>
                  Pay Status
                </option>
                <option value="Karachi">Partial-Paid</option>
                <option value="Skardu">Paid</option>
              </select>
            </div>
          </li>

          <li>
            <div className="formInput">
              <select {...register("CustomerType")} name="" className="uk-select" style={{borderRadius:'0px'}}>
                <option value="" selected>
                  Customer Type
                </option>
                <option value="Karachi">Corporate</option>
                <option value="Skardu">Individual</option>
              </select>
            </div>
          </li>

          <li>
            <div className="formInput">
            <label>Start Date</label>

                  <input
                  type="date"
                  {...register('startDate', { required: true })}
                  className="uk-input"
                />
              
            </div>
          </li>

          <li>
            <div className="formInput">
            <label>End Date</label>

            <input
        type="date"
        {...register('endDate', { required: true })}
        className="uk-input"
      />
              
            </div>
          </li>
        </ul>

      
        <div className="right">

        <button
                className=" uk-button uk-button-secondary"
              >
                Apply
              </button>

        {/* <button
                className=" uk-button uk-button-primary"
              >
                Clear
              </button> */}
        </div>
        </form>
      </div>
    </div>
  );
};

export default Filterhead;
